import { SmoothScroll } from '@/features/smooth-scroll/ui/SmoothScroll';

export { SmoothScroll };
